import React from "react";
import PropTypes from "prop-types";
import mapDeviceTags from "./mapDeviceTags";

const DeviceTagList = props => (
  <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center" }}>
    {mapDeviceTags(props.deviceTags).map(tag => (
      <span
        key={tag.value}
        style={{
          backgroundColor: "#e5e7eb",
          display: "inline-block",
          padding: "4px 10px",
          borderRadius: "12px",
          fontSize: "13px",
          fontWeight: "500",
          whiteSpace: "nowrap"
        }}
      >
        {tag.value}
      </span>
    ))}
  </div>
);

DeviceTagList.propTypes = {
  deviceTags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string
    })
  ).isRequired
};

export default DeviceTagList;
